import * as React from 'react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Grid from '@mui/material/Grid';
import { useTheme } from '@mui/system';
import { useTranslation } from 'react-i18next';

const whiteLogos = [
  "/static/images/enbw_black_and_white_dark.svg",
  "/static/images/google_white.svg",
  "/static/images/y1logo_white.svg",
  "/static/images/bfk_white.svg",
];

const darkLogos = [
  "/static/images/enbw_black_and_white.svg",
  "/static/images/google.svg",
  "/static/images/y1logo.svg",
  "/static/images/bfk.svg",
];

const logoStyle = {
  width: '100px',
  height: '80px',
  margin: '0 32px',
  opacity: 0.7,
};

export default function LogoCollection() {
  const theme = useTheme();
  const logos = theme.palette.mode === 'light' ? darkLogos : whiteLogos;
  const { t } = useTranslation();

  return (
    <Box id="logoCollection" sx={{ py: 4 }}>
      <Typography
        component="p"
        variant="subtitle2"
        align="center"
        color="text.secondary"
      >
        {t('logo.workedtogether')}
      </Typography>
      <Grid container justifyContent="center" sx={{ mt: 0.5, opacity: 0.6 }}>
        {logos.map((logo, index) => {
          // if logo contains google resize it to half size
          if (logo.includes('google')) {
            return (
              <Grid item key={index}>
                <img
                  src={logo}
                  alt={`Company number ${index + 1}`}
                  style={{ ...logoStyle, width: '40px' }}
                />
              </Grid>)
          } else if (logo.includes('enbw')) {
            return (
              <Grid item key={index}>
                <img
                  src={logo}
                  alt={`Company number ${index + 1}`}
                  style={{ ...logoStyle, width: '140px' }}
                />
              </Grid>)
          } else if (logo.includes('bfk')) {
            return (
              <Grid item key={index}>
                <img
                  src={logo}
                  alt={`Company number ${index + 1}`}
                  style={{ ...logoStyle, width: '60px' }}
                />
              </Grid>)
          }
          return (
          <Grid item key={index}>
            <img
              src={logo}
              alt={`Company number ${index + 1}`}
              style={logoStyle}
            />
          </Grid>)
       })}
      </Grid>
    </Box>
  );
}
